module.exports = __webpack_public_path__ + "static/media/lumensearch.6e7bd148.png";